<template>
  <div id="assembleSubtest">
    <div>
      <table v-if="$store.state.tryout.status != 'PUBLISHED'">
        <tr>
         <td>
            <select name="type" class="form-control" v-model="sourceType">
              <option value="INTERNAL">Internal</option>
              <option value="EXTERNAL">External</option>
            </select>
          </td>
          <td>
            <select name="type" class="form-control" v-model="subtestType">
              <option value="normal">Normal</option>
              <option value="anchor">Anchor</option>
            </select>
          </td>
          <td>
            <select name="type" class="form-control" v-model="questionType">
              <option value="PG">Pilihan Ganda</option>
              <option value="TUR" v-if="sourceType === 'INTERNAL'">TUR</option>
              <option value="MTF" v-if="sourceType === 'INTERNAL'">MTF</option>
            </select>
          </td>
           <td>
            <app-autocomplete :sourcetype="sourceType" v-if="subtestType == 'normal'" :data="topics" depth="2" placeholder="Cari bab / sub bab ..." v-on:selected="assignTopic($event)" resetable="true"></app-autocomplete>
            <app-itemchooser v-if="subtestType == 'anchor'" :subject="selectedSubject" :sourcetype="sourceType" v-on:selected="assignAnchor($event)"></app-itemchooser>
          </td>
        </tr>
      </table>
    </div>
    <div>
      <table class="table table-hover">
	      <tr v-bind:key="index" v-for="(subtestDetail, index) in details">
          <!-- {{subtestDetail}} -->
          <div v-if="subtestDetail.source === 'EXTERNAL'" style="display:flex; width:100%; flex-flow:row;">
            <td>{{ subtestDetail.sequence }}</td>
            <td v-if="subtestDetail.is_anchor">Kode Soal: {{ subtestDetail.item_code }}
            <p style="margin-top:10px;">
              <span style="margin:5px; background:lightgray; border-radius:8px; padding:5px;">{{ subtestDetail.source}}</span>
              <span style="margin:5px; background:lightgray; border-radius:8px; padding:5px;">{{ subtestDetail.question_type}}</span>
            </p></td>
            <td v-else>Topik: {{ getTopicText(subtestDetail) }}
              <!-- <td v-else>Topik: {{ subtestDetail.text }} -->
              <p style="margin-top:10px;">
                <span style="margin:5px; background:lightgray; border-radius:8px; padding:5px;">{{ subtestDetail.source}}</span>
                <span style="margin:5px; background:lightgray; border-radius:8px; padding:5px;">{{ subtestDetail.question_type}}</span>
              </p>
            </td>
            <td class="text-right" v-if="$store.state.tryout.status != 'PUBLISHED'">
              <button type="button" class="btn btn-success btn-small" @click="moveDown(subtestDetail)"><span class="fa fa-caret-down"></span></button>
              <button type="button" class="btn btn-success btn-small" @click="moveUp(subtestDetail)"><span class="fa fa-caret-up"></span></button>
              <button type="button" class="btn btn-danger btn-small" @click="remove(subtestDetail)"><span class="fa fa-times"></span></button>
            </td>
          </div>
          <div v-if="subtestDetail.source === 'INTERNAL'" style="display:flex; width:100%; flex-flow:row;">
            <td>{{ subtestDetail.sequence }}</td>
            <td v-if="subtestDetail.is_anchor">
              Kode Soal: {{ subtestDetail.item_code }}
              <p style="margin-top:10px;">
              <span style="margin:5px; background:lightgray; border-radius:8px; padding:5px;">{{ subtestDetail.source}}</span>
              <span style="margin:5px; background:lightgray; border-radius:8px; padding:5px;">{{ subtestDetail.question_type}}</span>
              </p>
            </td>
            <td v-else>
              Topik: {{ getTopicText(subtestDetail) }}
              <p style="margin-top:10px;">
              <span style="margin:5px; background:lightgray; border-radius:8px; padding:5px;">{{ subtestDetail.source}}</span>
              <span style="margin:5px; background:lightgray; border-radius:8px; padding:5px;">{{ subtestDetail.question_type}}</span>
              </p>
            </td>
            <td class="text-right" v-if="$store.state.tryout.status != 'PUBLISHED'">
              <button type="button" class="btn btn-success btn-small" @click="moveDown(subtestDetail)"><span class="fa fa-caret-down"></span></button>
              <button type="button" class="btn btn-success btn-small" @click="moveUp(subtestDetail)"><span class="fa fa-caret-up"></span></button>
              <button type="button" class="btn btn-danger btn-small" @click="remove(subtestDetail)"><span class="fa fa-times"></span></button>
            </td>
          </div>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import Autocomplete from "@/components/plugins/Autocomplete"
import ItemChooser from "@/components/plugins/ItemChooser"
import SubtestDetail from "@/components/tryout/models/SubtestDetail.js"
import ItembankService from "@/services/itembank.js"

export default {
  name: 'app-assemble-subtest',
  components: {
    'app-autocomplete': Autocomplete,
    'app-itemchooser': ItemChooser
  },
  props: {
    subject: null
  },
  data: function() {
    return {
      showModal: false,
      details: [],
      sourceType: null,
      questionType: null,
      topics: [],
      lastSequence: 0,
      subtestType: 'normal'
    };
  },
  computed: {
    selectedSubject: function() {
      if (this.$store.getters.selectedSubtest) {
        var subject = {
          nama: this.$store.getters.selectedSubtest.subject_name,
          code: this.$store.getters.selectedSubtest.subject_code,
          picture: this.$store.getters.selectedSubtest.subject_picture
        }
        return subject
      }

      return this.subject
    }
  },
  methods: {
    getTopicText: function(subtestDetail) {
      try{
        console.log(subtestDetail)
        if (this.topics.length == 0) return

        var text = ''
        var chapter = this.topics.find(function(element) {
          return element.kode == parseInt(subtestDetail.bab_code)
        })

        console.log(chapter)
        text += chapter.nama

        if (subtestDetail.sub_bab_code) {
          var subChapter = chapter.subs.find(function(element) {
            return element.kode == parseInt(subtestDetail.sub_bab_code)
          })

          console.log(subChapter)
          text += ' >> ' + subChapter.nama
        }

        return text

      } catch (err){
        console.log(err)
        return subtestDetail.text
      }
    },
    assignTopic: function(selectedTopic) {
      var context = this
      if(this.sourceType === 'EXTERNAL') {
        var chapterId = selectedTopic.data[0]
        var chapter = this.topics.find(function(element) {
          return element.id == chapterId
        })

        var detail = {}
        detail.sequence = this.lastSequence + 1
        detail.is_anchor = false
        detail.bab_code = chapter.kode

        if (selectedTopic.data[1] != 0) {
          var subChapterId = selectedTopic.data[1]
          var subChapter = chapter.subs.find(function(element) {
            return element.id == subChapterId
          })
          detail.sub_bab_code = subChapter.kode
        }

        detail.text = selectedTopic.text
        detail.source = 'EXTERNAL'
        detail.question_type = 'PG'
        var level = this.$store.state.tryout.level
        var type = this.$store.state.tryout.type
        var code = this.generateItemCode(detail.bab_code, detail.sub_bab_code, type, level)
        

        // console.log(level)
        ItembankService.searchRandomItemByItemCodeAndGrade(code, function(result) {
          if (result.success) {
            context.details.push(detail)
            context.lastSequence++
          } else {
            var altCode = code.substring(0, 1) + '4' + code.substring(2)
            ItembankService.searchRandomItemByItemCodeAndGrade(altCode, function(altResult) {
              if (altResult.success) {
                context.details.push(detail)
                context.lastSequence++
              } else {
                window.alert('Topik "' + detail.text + '" tidak memiliki soal')
              }
            })
          }
        })
      } else {
        // console.log(selectedTopic)
        var chapterId = selectedTopic.data[0]
        var chapter = this.topics.find(function(element) {
          return element.name == chapterId
        })
        // console.log(chapter)
        var detail = {}
        detail.sequence = this.lastSequence + 1
        detail.is_anchor = false
        detail.bab_code = chapter.name

        if (selectedTopic.data[1] != 0) {
          var subChapterId = selectedTopic.data[1].split(" >> ")

          var subChapter = chapter.subs.find(function(element) {
            return element.name == subChapterId[1]
          })
          // console.log(subChapter)
          detail.sub_bab_code = subChapter.name
        }
        
        detail.text = selectedTopic.text
        detail.source = 'INTERNAL'
        detail.question_type = context.questionType
        // console.log(context.subject)
        let params = {
          level: context.$store.state.tryout.level,
          mapel_code: context.subject.code,
          bab_name: detail.bab_code,
          subbab_name: detail.sub_bab_code,
          subsubbab_name :null,  
          question_type: detail.question_type,
          item_type: context.$store.state.tryout.type,
        }
        ItembankService.searchRandomItemByItemNameV2(params, function(result) {
          // console.log(result)
          if (result.data && result.data.length > 0 ) {
            detail.item_code = result.data[0].code
            context.details.push(detail)
            context.lastSequence++
          } else {
            window.alert('Topik "' + detail.text + '" tidak memiliki soal')
          }
        })
      }
    },
    generateItemCode: function(babCode, subBabCode, type, level) {
      var code = ''
      switch (level) {
        case 'SMA':
          code += '3'
          break
        case 'SMP':
          code += '2'
          break
        case 'SD':
          code += '1'
          break
        default:
          code += '3'
      }

      switch (type) {
        case 'UAS':
          code += '3'
          break
        case 'UJIAN_AKHIR_SEKOLAH':
          code += '3'
          break
        case 'UJIAN_SEKOLAH':
          code += '3'
          break
        case 'PENILAIAN_TENGAH_SEMESTER':
          code += '3'
          break
        case 'PENILAIAN_AKHIR_SEMESTER':
          code += '3'
          break
        case 'UN':
          code += '2'
          break
        case 'UJIAN_AKHIR_NASIONAL':
          code += '2'
          break
        case 'SBMPTN':
          code += '1'
          break
        case 'UJIAN_MANDIRI':
          code += '1'
          break
        default:
          code += '4'
      }

      code += this.subject.code
      code += babCode

      if (subBabCode) code += subBabCode

      return code
    },
    assignAnchor: function(anchorItem) {
      var detail = {}
      detail.sequence = this.lastSequence + 1
      detail.is_anchor = true
      detail.item_code = anchorItem.data[0]
      detail.source = this.sourceType
      if(this.sourceType === 'INTERNAL') detail.question_type = anchorItem.data[6]
      else detail.question_type = 'PG'
      var found = this.details.find(function(d) {
        return d.item_code == detail.item_code
      })
      if (!found) {
        this.details.push(detail)
        this.lastSequence++
      }
    },
    moveUp: function(subtestDetail) {
      if (currentIndex === 0) return
      var currentIndex = subtestDetail.sequence - 1
      var element = this.details.splice(currentIndex, 1)[0]
      this.details.splice(currentIndex - 1, 0, element)
      this.reOrderingSequence()
    },
    moveDown: function(subtestDetail) {
      if (currentIndex === this.details.length - 1) return
      var currentIndex = subtestDetail.sequence - 1
      var element = this.details.splice(currentIndex, 1)[0]
      this.details.splice(currentIndex + 1, 0, element)
      this.reOrderingSequence()
    },
    remove: function(subtestDetail) {
      var confirmed = window.confirm('Apakah anda yakin akan menghapus soal ini?')
      if (confirmed) {
        var index  = subtestDetail.sequence - 1
        this.details.splice(index, 1)
        this.reOrderingSequence()
      }
    },
    reOrderingSequence: function() {
      var context = this
      this.lastSequence = 0
      this.details.forEach(function(detail) {
        detail.sequence = context.lastSequence + 1
        context.lastSequence++
      })
    },
    loadTopics: function() {
      var context = this
      context.topics = []
      ItembankService.getListOfTopic(this.subject.code, function(result) {
        if (result.success) {
          result.data.forEach(function(topic) {
            context.topics.push(topic)
            // console.log(topic)
          })
        }
      })
    },
    loadTopicsV2: function() {
      var context = this
      context.topics = []
      ItembankService.getListOfTopicV2(this.subject.code, function(result) {
        if (result.success) {
          result.data.forEach(function(topic) {
            context.topics.push(topic)
            // console.log(topic)
          })
        }
      })
    }
  },
  watch: {
    'subject': function(val) {
      // this.loadTopics()
      this.sourceType = null
      this.questionType = null
    },
    'details': function(val) {
      this.$emit('updated', this.details)
    },
    'sourceType': function(to, from) {
    

      if(to === 'INTERNAL') this.loadTopicsV2()
      if(to === 'EXTERNAL') this.loadTopics()
    }
  },
  mounted: function() {
    this.loadTopics()
    if (this.$store.getters.selectedSubtest) {

      var context = this
      this.$store.getters.selectedSubtest.details.forEach(function(detail) {
        context.details.push(detail)
      })

      this.details.sort(function(a, b) {
        return a.sequence - b.sequence
      })

      this.lastSequence = this.details.length
    }
  }
};
</script>



// WEBPACK FOOTER //
// AssembleSubTest.vue?36c0f687